function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import { PluginsContext, isMultiPlugin } from '@deephaven/plugin';
import { loadModulePlugins } from "../plugins/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * PluginsBootstrap component. Handles loading the plugins.
 */
export function PluginsBootstrap(_ref) {
  var pluginsUrl = _ref.pluginsUrl,
    getCorePlugins = _ref.getCorePlugins,
    children = _ref.children;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    plugins = _useState2[0],
    setPlugins = _useState2[1];
  useEffect(function initPlugins() {
    var isCanceled = false;
    function loadPlugins() {
      return _loadPlugins.apply(this, arguments);
    }
    function _loadPlugins() {
      _loadPlugins = _asyncToGenerator(function* () {
        var _yield$getCorePlugins;
        var corePlugins = (_yield$getCorePlugins = yield getCorePlugins === null || getCorePlugins === void 0 ? void 0 : getCorePlugins()) !== null && _yield$getCorePlugins !== void 0 ? _yield$getCorePlugins : [];
        var pluginModules = yield loadModulePlugins(pluginsUrl);
        if (!isCanceled) {
          // Flatten MultiPlugins in core plugins
          var corePluginPairs = corePlugins.flatMap(plugin => {
            if (isMultiPlugin(plugin)) {
              return plugin.plugins.map(innerPlugin => [innerPlugin.name, innerPlugin]);
            }
            return [[plugin.name, plugin]];
          });
          setPlugins(new Map([...corePluginPairs, ...pluginModules]));
        }
      });
      return _loadPlugins.apply(this, arguments);
    }
    loadPlugins();
    return () => {
      isCanceled = true;
    };
  }, [pluginsUrl, getCorePlugins]);
  return /*#__PURE__*/_jsx(PluginsContext.Provider, {
    value: plugins,
    children: children
  });
}
export default PluginsBootstrap;
//# sourceMappingURL=PluginsBootstrap.js.map